import { createApp } from 'vue'
import SubstudyList from '../components/substudies/SubstudyList.vue';
import SubstudyDetail from '../components/substudies/SubstudyDetail.vue';

// Substudy List
if (document.getElementById('substudies-list-container')) {
  var substudies = createApp({})
  substudies.component('SubstudyList', SubstudyList)
  substudies.mount('#substudies-list-container')
}

// Substudy detail
if (document.getElementById('substudy-detail-container')) {
	var substudyDetail = createApp({})
	substudyDetail.component('SubstudyDetail', SubstudyDetail)
	substudyDetail.mount('#substudy-detail-container')
}